export const $ = <T extends Element>(query: string, context = document) => context.querySelector<T>(query);

export const $$ = (query: string, context = document) => Array.from(context.querySelectorAll(query));

export const getHeader = () => $<HTMLElement>('#EDITOR_X_HEADER');

export const getFooter = () => $<HTMLElement>('#EDITOR_X_FOOTER');

export const getNavigationMenu = () => $<HTMLUListElement>('[data-hook="editorx-header-navigation-menu"]')!;

export const getLanguagePickerButton = () => $<HTMLButtonElement>('[data-bi-name="language"]')!;
